const breakpoints = [1080, 640, 384, 256, 128, 96, 64, 48];

const unsplashLink = (id, name, width, height) => {
  return () => {};
};

const unsplashPhotos = [
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669270268/hobby/Thank_you-01_pctuat.png",
    width: 13500,
    height: 4500,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669270259/hobby/FULL_yhso0z.png",
    width: 13500,
    height: 4500,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669270240/hobby/188697799_900701460493419_4975121849553295174_n_ykvtla.jpg",
    width: 1080,
    height: 1080,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669270239/hobby/117331967_320482612646405_1680869703142798298_n_gxaib3.jpg",
    width: 1080,
    height: 1080,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669270240/hobby/187665919_165939372139161_9215332136924770164_n_x4anlq.jpg",
    width: 1080,
    height: 1080,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669270239/hobby/118969387_906116226544419_891454906725268825_n_kim1cy.jpg",
    width: 1080,
    height: 1080,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669270240/hobby/171037635_156503959714561_554451283162713624_n_b3eqdy.jpg",
    width: 1080,
    height: 1080,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669270240/hobby/180965131_144474957641501_3851317700213343519_n_vh2row.jpg",
    width: 1080,
    height: 1080,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669270239/hobby/125351855_377588073294766_4528844771068815889_n_panatn.jpg",
    width: 1080,
    height: 1080,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669270239/hobby/117154463_183435379891532_7067081096443773656_n_chqrei.jpg",
    width: 1080,
    height: 1080,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669270239/hobby/130894380_802486527149971_7353232616874652072_n_mbtrxg.jpg",
    width: 1080,
    height: 1080,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669270239/hobby/122037254_2753461674942816_6340696361186998101_n_ooey6m.jpg",
    width: 1080,
    height: 1080,
  },
  // Posters
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669267505/hobby/photo_2022-11-24_01-18-42_vl51ua.jpg",
    width: 1280,
    height: 1279,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669267504/hobby/photo_2022-11-24_01-18-48_lrrzrx.jpg",
    width: 720,
    height: 1280,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669267504/hobby/photo_2022-11-24_01-18-52_dlauyr.jpg",
    width: 960,
    height: 1280,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669267503/hobby/photo_2022-11-24_01-18-50_tcziw9.jpg",
    width: 959,
    height: 1280,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669267503/hobby/photo_2022-11-24_01-18-56_ivn0q9.jpg",
    width: 989,
    height: 1280,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669267503/hobby/photo_2022-11-24_01-18-54_dy9hu2.jpg",
    width: 959,
    height: 1350,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669265309/hobby/3_ypdofj.jpg",
    width: 1080,
    height: 1350,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669265308/hobby/1_wlqk6d.jpg",
    width: 1080,
    height: 1350,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669265308/hobby/4_kkroyo.jpg",
    width: 1080,
    height: 1080,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669265307/hobby/6_ahmz5d.jpg",
    width: 1080,
    height: 1081,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669265307/hobby/2_czkqk4.jpg",
    width: 1080,
    height: 1080,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669265307/hobby/7_q62pph.jpg",
    width: 1080,
    height: 1350,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669265307/hobby/21_yucxhu.jpg",
    width: 1080,
    height: 720,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669265306/hobby/24_kjjhaf.jpg",
    width: 1080,
    height: 864,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669265306/hobby/25_nrjpht.jpg",
    width: 1080,
    height: 1350,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669265306/hobby/26_jcumms.jpg",
    width: 966,
    height: 1208,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669265306/hobby/22_zwtz1f.jpg",
    width: 1080,
    height: 1080,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669265305/hobby/23_sleu37.jpg",
    width: 1080,
    height: 1350,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669265305/hobby/66804349_125186998455166_3841920788395637283_n_n8ejdf.jpg",
    width: 1080,
    height: 720,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669265305/hobby/15_vx7msn.jpg",
    width: 1080,
    height: 1196,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669265305/hobby/18_zgiolk.jpg",
    width: 1080,
    height: 1080,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669265305/hobby/19_gja5d0.jpg",
    width: 1080,
    height: 864,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669265305/hobby/20_jyc2pw.jpg",
    width: 1080,
    height: 1350,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669265304/hobby/16_vsp05z.jpg",
    width: 1080,
    height: 1350,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669265304/hobby/17_dxp8y1.jpg",
    width: 1080,
    height: 1350,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669265304/hobby/14_ipvslk.jpg",
    width: 1080,
    height: 1196,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669265304/hobby/10_mbyx4b.jpg",
    width: 1080,
    height: 1080,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669265303/hobby/13_uxoex6.jpg",
    width: 1080,
    height: 864,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669265303/hobby/12_riv0l8.jpg",
    width: 1080,
    height: 1080,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669265302/hobby/11_djxlmh.jpg",
    width: 1080,
    height: 1350,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669265302/hobby/5_rujkdj.jpg",
    width: 1080,
    height: 1080,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669265302/hobby/9_otfwkj.jpg",
    width: 1080,
    height: 1350,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669265302/hobby/8_asrwoh.jpg",
    width: 1080,
    height: 1440,
  },
  {
    id: "https://res.cloudinary.com/dcbw508s1/image/upload/v1669265301/hobby/27_exnjlw.jpg",
    width: 1080,
    height: 720,
  },
];

const photos = unsplashPhotos.map((photo) => ({
  src: photo.id,
  width: photo.width,
  height: photo.height,
  images: breakpoints.map((breakpoint) => {
    const height = Math.round((photo.height / photo.width) * breakpoint);
    return {
      src: photo.id,
      width: breakpoint,
      height,
    };
  }),
}));

export default photos;
